import React from 'react';
import CellCulture1 from '../assets/img/Cell-culture-bag.jpg';
import CellCulture2 from '../assets/img/Cell-culture-bag-1.jpg';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';
import img1 from '../assets/img/banners/gmp-product.jpeg';
import img2 from '../assets/img/macs-gmp1.jpg';
import img3 from '../assets/img/macs-gmp2.jpg';
import img4 from '../assets/img/macs-gmp3.jpg';
import img5 from '../assets/img/macs-gmp4.jpg';


function GmpProducts() {
    return (
        <>
            <Header1 />
            <section className='blog-wrapper news-wrapper section-padding'>
                <div className='container'>
                    <div className='row'>
                        <div className="col-md-12">
                            <div className="news-content">
                                <div className="section-heading mb-3">
                                    <p><strong>MACS GMP</strong> Products</p><h5></h5><p className='mb-3'></p>
                                </div>
                                <img src={img1} className='w-100 mb-3' alt="" />
                                <div className="row">
                                    <strong>
                                        <ul>
                                            <li className='li-arrow'>Compliant – manufacture of cellular products according to GMP guidelines</li>
                                            <li className='li-arrow'>Optimized – CliniMACS® System in combination with the MACS® GMP Products</li>
                                        </ul>
                                    </strong>
                                    <p className='mb-3'></p>
                                    <p className='mb-3'>
                                        The quality of starting materials dramatically influences the properties of the final cellular product. For the development of applications involving cellular therapies, strict procedures according to GMP guidelines are mandatory.
                                    </p>
                                    <p className='mb-3'>
                                        All materials used, such as antibodies, antigens, cytokines, cell culture bags, and cell culture media, must comply with GMP specifications.
                                    </p>
                                    <p className='mb-3'>
                                        Miltenyi Biotec strives to minimize the risk of contamination and maximize the consistency and quality of all its products through highest manufacturing standards, strictly controlled processes and a certfied ISO 9001 quality system.
                                    </p>
                                    <p className='mb-3'>
                                        MACS® GMP activation and expansion tools include GMP-grade monoclonal antibodies and antibody-coated particles (ExpAct Treg Beads) for clinical-grade activation and expansion of cells
                                    </p>
                                    <p className='mb-3'>
                                        MACS® GMP Antigens, including PepTivator® Peptide Pools, recombinant protein and antigen lysate, are designed for the efficient stimulation of antigen-specific T cells.
                                    </p>
                                    <p className='mb-3'>
                                        MACS® GMP Media have been developed for today's requirements for clinical grade manufacturing of cellular products. These next generation cell culture media are adapted to the needs of each cell type and are manufactured under strict quality assessment
                                    </p>
                                    <p className='mb-3'>
                                        MACS® GMP Fluorescent Antibodies have been developed for flow cytometry analysis and subsequent flow sorting of cell populations from heterogeneous human blood products in the clinical setting. A wide range of specificities and fluorochromes are available. A special custom conjugation program has been introduced that allows the GMP-compliant manufacture of fluorescent antibodies.
                                    </p>
                                    <p className='mb-3'>
                                        MACS® GMP Cytokines and Growth Factors are highly active and pure recombinant proteins that enable consistent cell culture results. Highest product standards are ensured by rigorous quality control (QC) tests. Each product is supplied with a lot-specific certificate of analysis (CoA) that confirms the stringent specifications. These products have been developed for today's requirements for clinical grade manufacturing of cellular products and are manufactured in accordance with relevant GMP guidelines.
                                    </p>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-md-3">
                                        <div className="card">
                                            <img src={img2} className="card-img-top" alt="MACS GMP Activation and Expansion Tools..." />
                                            <div className="card-body">
                                                <p className="card-title">
                                                    MACS GMP Activation and Expansion Tools
                                                </p>
                                                <p className="card-text">Soluble antibodies, antibody-coated cell-sized particles, and nano-sized polymeric matrix </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="card">
                                            <img src={img3} className="card-img-top" alt="MACS GMP Cytokines and Growth Factors" />
                                            <div className="card-body">
                                                <p className="card-title">
                                                MACS GMP Cytokines and Growth Factors
                                                </p>
                                                <p className="card-text">High-quality cytokines and growth factors as ancillary materials for ex vivo cell manufacturing</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="card">
                                            <img src={img4} className="card-img-top" alt="MACS GMP Cell Culture Media" />
                                            <div className="card-body">
                                                <p className="card-title">
                                                MACS GMP Cell Culture Media
                                                </p>
                                                <p className="card-text">Excellent cell growth and differentiation under serum-free conditions</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="card">
                                            <img src={img5} className="card-img-top" alt="MACS GMP Antigens and Peptide Pools" />
                                            <div className="card-body">
                                                <p className="card-title">
                                                MACS GMP Antigens and Peptide Pools&nbsp; 
                                                </p>
                                                <p className="card-text">Reagents for effective antigen-specific T cell stimulation and dendritic cell vaccination research</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="divider my-2"></div>
                                <p className='mb-3'>
                                </p><h5>Cell Culture Bags for expansion or differentiation</h5>
                                <p className='mb-3'></p>
                                <div className='row'>
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-6">
                                                <img src={CellCulture1} alt="" className='w-100' />
                                            </div>
                                            <div className="col-md-6">
                                                <p className='mb-3'>
                                                    Miltenyi Biotec offers MACS GMP Cell Differentiation and MACS GMP Cell Expansion Bags for expansion, generation and differentiation of cells from heterogeneous, hematologic cell populations.
                                                </p>
                                                <p className='mb-3'>
                                                    The gas permeable and transparent MACS® GMP Cell Culture Bags have been developed as valuable tools for GMP-compliant cell culturing in functionally closed systems.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="divider my-2"></div>
                                <div className="col-md-12">
                                    <div className='row'>
                                        <div className="col-md-6">
                                            <p className='mb-3'></p>
                                            <strong>
                                                <ul >
                                                    <li className='li-arrow'>CryoMACS Freezing products for cryopreservation</li>
                                                    <li className='li-arrow'>Unique bag concept with few welds making CryoMACS® Freezing Bags highly durable</li>
                                                    <li className='li-arrow'>Corresponding overwrap bag to protect freezing bag and stored product</li>
                                                    <li className='li-arrow'>Single, sterile packaging in one pouch of both freezing bag and overwrap bag</li>
                                                </ul>
                                            </strong>
                                            <p className='mb-3'></p>
                                        </div>
                                        <div className="col-md-6">
                                            <p className='mb-3'>
                                                CryoMACS Freezing Bags and CryoMACS DMSO are the right step towards safe cryopreservation of cells at ultra low temperatures.
                                                <img src={CellCulture2} alt="" className='w-100' />
                                            </p>
                                        </div>

                                    </div>
                                </div>
                                <p className='mb-3'>
                                </p><ul >
                                    <li className='li-arrow'>
                                        <strong>CryoMACS DMSO is a pure and sterile dimethyl sulfoxide supplied in glass vials
                                            CryoMACS® Freezing Bags </strong> excel in proven quality, convenient handling, and are the right step towards safe cryopreservation. CryoMACS Freezing Products have been precisely developed in cooperation with our clients to set standards for cryopreservation. CryoMACS Freezing Bags are for cryopreservation applications at ultra low temperatures. CryoMACS DMSO 10 (EP, USP) is used as a cryoprotective agent.</li>
                                </ul>
                                <p className='mb-3'></p>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer1 />
        </>
    );
}

export default GmpProducts;
